// Lib
import * as Immutable from 'immutable';

// Constants
import {
    ELEMENT_RESIZING_ALLOW_ANY_ASPECT_RATIO,
    ELEMENT_RESIZING_END,
    ELEMENT_RESIZING_START,
    ELEMENT_RESIZING_UPDATE_ELEMENT_VALUES,
    ELEMENT_RESIZING_UPDATE_SCALE,
} from './resizingConstants';

const initialState = Immutable.fromJS({
    isResizeInProgress: false,
    resizingElements: Immutable.fromJS({}),
    origin: null,
    scale: null,
    allowChangingAspectRatio: false,
});

export default (state = initialState, action) => {
    switch (action.type) {
        case ELEMENT_RESIZING_START: {
            const resizingElements = Object.fromEntries(action.elementIds.map((id) => [id, {}]));
            return state
                .set('isResizeInProgress', true)
                .set('resizingElements', Immutable.fromJS(resizingElements))
                .set('origin', Immutable.fromJS(action.origin));
        }
        case ELEMENT_RESIZING_UPDATE_ELEMENT_VALUES:
            return state.setIn(['resizingElements', action.elementId], Immutable.fromJS(action.resizingValues));
        case ELEMENT_RESIZING_UPDATE_SCALE:
            return state.set('scale', Immutable.fromJS(action.scale));
        case ELEMENT_RESIZING_ALLOW_ANY_ASPECT_RATIO:
            return state.set('allowChangingAspectRatio', action.allowChangingAspectRatio);
        case ELEMENT_RESIZING_END:
            return initialState;
        default:
            return state;
    }
};
